import { network } from "../network/network.js";
const endpoint = "/profile";
export async function fetchProfile() {
    return await network(endpoint);
}
export async function updateProfile(profile) {
    return await network(endpoint, {
        method: "PATCH",
        json: profile,
    });
}
